import { FiArrowUp, FiArrowDown } from 'react-icons/fi'
import Pill from './Pill'

// Stat — KPI card con label, valor display, delta opcional con flecha y sparkline.

export default function Stat({ label, value, unit, delta, deltaTone = 'emerald', spark, sub, className = '' }) {
  return (
    <div className={`ui-card p-5 ${className}`}>
      <div className="eyebrow">{label}</div>
      <div className="mt-2 flex items-end justify-between gap-2">
        <div className="font-display text-[44px] leading-none tnum">
          {value}
          {unit && <span className="text-[var(--ink-3)] text-[20px] ml-1.5 font-sans">{unit}</span>}
        </div>
        {spark}
      </div>
      <div className="mt-3 flex items-center gap-2 text-[12px] text-[var(--ink-3)]">
        {delta && (
          <Pill tone={deltaTone}>
            {deltaTone === 'red' ? <FiArrowDown size={11} /> : <FiArrowUp size={11} />}
            <span className="tnum">{delta}</span>
          </Pill>
        )}
        {sub && <span>{sub}</span>}
      </div>
    </div>
  )
}
